import {Divider, Flex, Text} from "@chakra-ui/react";

export function DateDivider(p: {label: string}) {
    return <Text
        as="span"
        bg="gray.200"
        color="gray.700"
        fontSize="14px"
        fontWeight="semibold"
        textAlign="center"
        alignSelf="center"
        px={3}
        py={1}
        borderRadius="lg"
    >
        {p.label}
    </Text>;
};

export function CentralBubble(p:{note: string}) {
    return <Text
        bg="primary.900"
        color="white"
        fontSize="0.9em"
        alignSelf="center"
        textAlign="center"
        py={1}
        px={3}
        mx={3}
        borderRadius="lg"
        whiteSpace="pre-wrap"
        style={{textWrap: "pretty"}}
    >
        {p.note}
    </Text>
};

export function UnreadDivider(p: {count: number}) {
    return <Flex alignItems="center" gap="4px" textAlign="center" my={3}>
        <Divider borderColor="primary.900" h="3px" flex="2 1 auto"/>
        <Text
            as="span"
            bg="primary.500"
            color="white"
            px={3}
            py={1}
            borderRadius="lg"
            fontSize=".8em"
            fontWeight="semibold"
            flex="0 0 auto"
        >
            {p.count} New message{p.count > 1 ? "s" : ""}
        </Text>
        <Divider borderColor="primary.900" h="3px" flex="2 1 auto"/>
    </Flex>;
};
